import {
  IFocalStatRepository,
  FocalStatEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class FocalStatRepository implements IFocalStatRepository {
  async getStats(): Promise<ResponseValueObject<FocalStatEntity[]>> {
    return new ResponseValueObject(true, [
      { label: 'CONFLICTOS',      value: '08' },
      { label: 'ALTA TENSIÓN',    value: '03' },
      { label: 'COM. AFECTADAS',  value: '24' },
      { label: 'INFRAEST. RIESGO', value: '12' },
    ]);
  }
}
